export function paramsSerializer(params) {
  return Object.keys(params).reduce((acc, key) => {
    let account = acc;
    account += `${key}=${params[key]}&`;
    return account;
  }, '');
}
